export default "__VITE_ASSET__BDDThymP__"